import React, { useEffect, useState } from 'react';
import { Box, Container, Stack, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { surface, brand, ink, line } from '../../theme/tokens';
import { formatINR } from '../../utils/farmStayPricing';

/**
 * Appears once the hero (and its own CTA) has scrolled away, so the price and
 * the way to book are never more than a glance off. Hidden until then, because
 * a bar competing with the hero is just noise.
 */
const StickyBookBar = ({ pkg }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1200,
        bgcolor: surface.card,
        borderTop: `1px solid ${line.default}`,
        boxShadow: '0 -10px 30px rgba(45,32,30,0.10)',
        transform: show ? 'translateY(0)' : 'translateY(110%)',
        transition: 'transform 420ms cubic-bezier(.22,.61,.36,1)',
        py: 1.5,
      }}
    >
      <Container maxWidth="lg">
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontWeight: 700, color: ink.primary, lineHeight: 1.2 }}>
              {pkg?.price != null ? formatINR(pkg.price) : 'On request'}
              <Typography component="span" sx={{ color: ink.secondary, fontWeight: 400, ml: 0.75, fontSize: 14 }}>
                per person, per night
              </Typography>
            </Typography>
            <Typography variant="caption" sx={{ color: ink.secondary, display: { xs: 'none', sm: 'block' } }}>
              {pkg?.nights ?? 2} nights · {pkg?.minGuests ?? 2}–{pkg?.maxGuests ?? 4} guests · the farm to yourselves
            </Typography>
          </Box>
          <Button
            component={RouterLink}
            to="/farm-stay/book"
            variant="contained"
            sx={{
              bgcolor: brand.mustard, backgroundImage: 'none', color: ink.onMustard,
              fontWeight: 700, whiteSpace: 'nowrap', px: { xs: 2.5, md: 4 },
              '&:hover': { bgcolor: '#C2A20E', backgroundImage: 'none' },
            }}
          >
            Check dates
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default StickyBookBar;
